var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"11","height":"13","fill":"none","key":0}),React.createElement("path",{"d":"M1.76041 7.01912L4.99952 7.01912L6.33285 7.01912L9.57195 7.01912C9.8186 7.01912 10.0186 6.72065 10.0186 6.35246C10.0186 5.98427 9.8186 5.68579 9.57195 5.68579L6.33285 5.68579L4.99952 5.68579L1.76041 5.68579C1.51376 5.68579 1.31381 5.98427 1.31381 6.35246C1.31381 6.72065 1.51376 7.01912 1.76041 7.01912Z","fill":"#00391E","key":1})]);
}

Minus.defaultProps = {"width":"11","height":"13","viewBox":"0 0 11 13","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
